// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3PUyL","content":"RecentSearches_content__16HpZ"};